<template>
  <v-container class="modulo-tercerizados">
    <v-card
      class="py-4 px-2 auth-content"
      tile
    >
      <v-form
        v-model="valid"
        ref="form"
      >
        <PageTitle
          main="Serviços"
          icon="mdi-pencil-box-outline"
          sub="Tercerizados"
          home="/servicos"
        />
        <input
          id="user-id"
          type="hidden"
          v-model="tercerizado.usuario"
        />
        <input
          id="rgf-id"
          type="hidden"
          v-model="tercerizado.id"
        />
        <v-row>
          <v-col
            cols="12"
            md="2"
          >
            <v-text-field
              v-model="codigo"
              label="Código"
              dense
              outlined
            >
              <v-icon
                slot="append"
                color="success"
                large
                @click="loadDialog"
              >
                mdi-magnify
              </v-icon>
            </v-text-field>
          </v-col>
          <v-col
            cols="12"
            md="2"
            v-if="codigo"
          >
            <v-checkbox
              v-model="tercerizado.inativar"
              label="Inativar tercerizado?"
              color="success"
              v-show="mode === 'save'"
            ></v-checkbox>
          </v-col>
          <v-col
            cols="12"
            md="2"
          >
            <v-menu
              v-model="menu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-mask="dtp"
                  v-model="data_pub"
                  label="Data de publicação.:"
                  dense
                  outlined
                  @blur="mudaData"
                >
                  <v-icon
                    slot="append"
                    color="success"
                    large
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-calendar
                  </v-icon>
                </v-text-field>
              </template>
              <v-date-picker
                locale="pt-br"
                v-model="date"
                @input="dateB"
              >
              </v-date-picker>
            </v-menu>
          </v-col>
          <v-col
            cols="12"
            md="2"
          >
            <v-text-field
              v-model="tercerizado.ano"
              label="Ano da publicação"
              required
              dense
              outlined
            >
            </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            sm="4"
            md="3"
            lg="2"
            class="mr-0 pr-0"
          >
            <v-text-field
              class="codigo mr-0"
              v-model="tercerizado.uid_pessoa"
              label="Código..."
              dense
              outlined
              flat
              @change="loadPedidoPessoaId()"
            >
              <v-btn
                class="btn-outer pa-0"
                slot="append"
                color="success"
                tile
                @click="loadFtPessoa"
              >
                <v-icon
                  class="mx-0"
                  color="white"
                >
                  mdi-magnify
                </v-icon>
              </v-btn>
              <v-btn
                class="btn-outer-right pa-0"
                slot="append"
                color="light"
                tile
                @click="loadAddPessoa"
              >
                <v-icon
                  class="mx-0"
                  color="black"
                  >
                  mdi-plus
                </v-icon>
              </v-btn>
            </v-text-field>
          </v-col>
          <v-col
            cols="12"
            sm="8"
            md="9"
            lg="6"
            class="mx-0 px-0"
          >
            <v-text-field
              class="v-busca-nome ml-0"
              v-model="tercerizado.nome_tercerizado"
              :loading="loading"
              aria-autocomplete="none"
              :search-input.sync="search"
              label="Nome"
              outlined
              dense
              @keyup.native="loadSeach()"
            >
              <v-icon
                v-if="tercerizado.nome_tercerizado"
                slot="append"
                color="black"
                @click.prevent="clPessoa"
              >
                mdi-close
              </v-icon>
            </v-text-field>
            <v-card
              v-show="listar === 'sim'"
              class="my-0 py-0"
            >
              <ul class="filtro">
                <li
                  v-for="item in items"
                  :key="item.id"
                >
                  <a @click="loadPedidoPessoaId( item, 'novo' )"> {{ item.agente }}</a>
                </li>
              </ul>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            md="4"
            lg="3"
          >
            <v-autocomplete
              v-model="tercerizado.uid_cargo"
              :items="cargos"
              required
              dense
              outlined
              label="Cargo ou função"
            >
              <v-btn
                class="btn-outer pa-0"
                slot="append"
                color="success"
                tile
                @click="loadFtCargo"
              >
                <v-icon
                  class="mx-0"
                  color="white"
                >
                  mdi-magnify
                </v-icon>
              </v-btn>
              <v-btn
                class="btn-outer-right pa-0"
                slot="append"
                color="light"
                tile
                @click="loadAddCargo"
              >
                <v-icon
                  class="mx-0"
                  color="black"
                >
                  mdi-plus
                </v-icon>
              </v-btn>
            </v-autocomplete>
          </v-col>
          <v-col
            cols="12"
            md="3"
            lg="2"
          >
            <v-autocomplete
              v-model="tercerizado.uid_orgao"
              :items="orgaos"
              clearable
              required
              dense
              outlined
              label="Órgão"
              @change="loadLotacao"
            >
            </v-autocomplete>
          </v-col>
          <v-col
            cols="12"
            md="5"
            lg="3"
          >
            <v-autocomplete
              :disabled="!this.tercerizado.uid_orgao"
              v-model="tercerizado.uid_lotacao"
              :items="lotacoes"
              clearable
              required
              dense
              outlined
              label="Lotação"
            >
            </v-autocomplete>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            md="3"
            lg="2"
          >
            <v-text-field
              label="Matricula"
              v-model="tercerizado.nr_matricula"
              dense
              outlined
            >
            </v-text-field>
          </v-col>
          <v-col
            cols="12"
            md="3"
            lg="2"
          >
            <v-text-field
              label="Carga horária"
              v-model="tercerizado.carga_horaria"
              dense
              outlined
            >
            </v-text-field>
          </v-col>
          <v-col cols="12" md="3" lg="2">
            <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
              offset-y min-width="auto">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-mask="dtIni" v-model="date_ini" label="Início do contrato" dense outlined
                  @blur="mudaDataC">
                  <v-icon slot="append" color="success" large v-bind="attrs" v-on="on">
                    mdi-calendar
                  </v-icon>
                </v-text-field>
              </template>
              <v-date-picker locale="pt-br" v-model="date2" @input="DateC">
              </v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" md="3" lg="2">
            <v-menu v-model="menu3" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
              offset-y min-width="auto">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-mask="dtFim" v-model="date_fim" label="Final do contrato" dense outlined
                  @blur="mudaDataB">
                  <v-icon slot="append" color="success" large v-bind="attrs" v-on="on">
                    mdi-calendar
                  </v-icon>
                </v-text-field>
              </template>
              <v-date-picker locale="pt-br" v-model="date3" @input="DateB">
              </v-date-picker>
            </v-menu>
          </v-col>
          <v-col
            cols="12"
            md="2"
          >
            <v-checkbox
              v-model="tercerizado.publicado"
              label="Publicar tercerizado?"
              color="success"
              v-show="mode === 'save'"
            ></v-checkbox>
          </v-col>
        </v-row>
        <v-card>
          <v-tabs
            background-color="primary"
            dark
            v-model="tabs"
          >
            <v-tab @click="loadAnexos">
              <v-icon class="mr-1">
                mdi-paperclip
              </v-icon>
              Anexos
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="tabs">
            <v-tab-item>
              <v-card flat>
                <v-row justify="space-around">
                  <v-col
                    cols="12"
                    md="12"
                  >
                    <v-card>
                      <v-data-table
                        :headers="headersAnexos"
                        :items="anexos"
                      >
                        <template v-slot:[`item.actions`]="{ item }">
                          <v-icon
                            medium
                            color="primary"
                            class="mr-2"
                            @click="loadAnexo(item)"
                          >
                            mdi-square-edit-outline
                          </v-icon>
                          <v-icon
                            medium
                            color="error"
                            class="mr-2"
                            @click="loadAnexo(item, 'remove')"
                          >
                            mdi-delete
                          </v-icon>
                        </template>
                      </v-data-table>
                      <v-row>
                        <v-col
                          cols="12"
                          md="6"
                        >
                          <v-btn
                            color="success"
                            class="ml-1 mb-3"
                            v-if="codigo"
                            @click="AddAnexo"
                          >
                            <v-icon left>
                              mdi-content-save
                            </v-icon>
                            Add anexo
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
        <v-row class="mt-1">
          <v-col
            cols="12"
            md="6"
          >
            <v-btn
              :disabled="!valid"
              color="success"
              class="ml-1 mr-4"
              v-if="mode === 'save'"
              @click="save"
            >
              <v-icon left>
                mdi-content-save
              </v-icon>
              Salvar
            </v-btn>
            <v-btn
              color="error"
              class="mr-4"
              v-if="mode === 'remove'"
              @click="remove"
            >
              <v-icon left>
                mdi-content-save
              </v-icon>
              Deletar
            </v-btn>
            <v-btn
              color="secondary"
              class="mr-4"
              @click="reset"
            >
              <v-icon left>
                mdi-broom
              </v-icon>
              Limpar
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
      <v-row justify="space-around">
        <v-col cols="auto">
          <v-dialog
            v-model="dialog"
            transition="dialog-bottom-transition"
            fullscreen
          >
            <template v-slot:default="dialog">
              <v-card>
                <v-toolbar
                  color="primary"
                  dark
                >
                  Pesquisar tercerizados
                </v-toolbar>
                <v-card-title>
                  <v-text-field
                    class="search"
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Pesquisar"
                    single-line
                    hide-details
                  >
                  </v-text-field>
                </v-card-title>
                <v-data-table
                  :headers="headers"
                  :items="tercerizados"
                >
                  <template v-slot:[`item.actions`]="{ item }">
                    <v-icon
                      medium
                      color="primary"
                      class="mr-2"
                      @click="loadTercerizado(item)"
                    >
                      mdi-square-edit-outline
                    </v-icon>
                    <v-icon
                      medium
                      color="error"
                      class="mr-2"
                      @click="loadTercerizado(item, 'remove')"
                    >
                      mdi-delete
                    </v-icon>
                  </template>
                </v-data-table>
                <v-card-actions class="justify-end">
                  <v-btn
                    color="error"
                    @click="dialog.value = false"
                  >Fechar</v-btn>
                </v-card-actions>
              </v-card>
            </template>
          </v-dialog>
        </v-col>
      </v-row>
      <v-container>
        <v-dialog
          v-model="DialogAnexo"
          transition="dialog-top-transition"
        >
          <v-card
            class="py-4 px-2 auth-content"
            tile
          >
            <div class="logo-foto ml-4 mt-5">
              <v-form
                v-model="valid"
                ref="form"
                class="altura"
              >
                <PageTitle
                  icon="mdi-pencil-box-outline"
                  sub="Adicionar anexo"
                />
                <input
                  id="user-id"
                  type="hidden"
                  v-model="anexo.usuario"
                />
                <input
                  id="anexo-id"
                  type="hidden"
                  v-model="anexo.id"
                />
                <v-row>
                  <v-col
                    cols="12"
                    md="7"
                    lg="8"
                  >
                    <v-text-field
                      v-model="anexo.nome"
                      type="text"
                      label="Nome do arquivo"
                      outlined
                      dense
                    >
                    </v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="5"
                    lg="4"
                  >
                    <v-menu
                      v-model="menu1"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-mask="datp"
                          v-model="date_pub"
                          label="Data de publicacao.:"
                          dense
                          outlined
                          @blur="mudaDataA"
                        >
                          <v-icon
                            slot="append"
                            color="success"
                            large
                            v-bind="attrs"
                            v-on="on"
                          >
                            mdi-calendar
                          </v-icon>
                        </v-text-field>
                      </template>
                      <v-date-picker
                        locale="pt-br"
                        v-model="date1"
                        @input="dateA"
                      >
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
                <v-row>
                  <input
                    accept="application/vnd.ms-excel, application/pdf"
                    prepend-icon="mdi-camera"
                    label="Anexo"
                    v-if="uploadReady"
                    type="file"
                    ref="file"
                    @change="selectFile()"
                  >
                </v-row>
              </v-form>
            </div>
            <v-card-actions class="justify-end">
              <v-btn
                color="success"
                class="mr-4"
                v-if="codigo"
                type="submit"
                @click.prevent="fileUpload()"
              >
                <v-icon left>
                  mdi-content-save
                </v-icon>
                Salvar
              </v-btn>
              <v-btn
                color="error"
                class="mr-4"
                v-if="codigo"
                @click="clearUpload"
              >
                Remover
                <v-icon left>
                  mdi-broom
                </v-icon>
              </v-btn>
              <v-btn
                color="danger"
                class="mr-4"
                @click="FecharDialog"
              >
                Sair
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-container>
    </v-card>
    <!-- Dialog cadastro de cargos e funções -->
      <v-container>
        <v-dialog
          v-model="dialogCargo"
          transition="dialog-top-transition"
        >
          <v-card tile>
            <v-toolbar
              color="primary"
              dark
              class="mb-2"
            >
              <v-icon large>
                mdi-pencil-box-outline
              </v-icon>
              Adicionar cargos e funções
            </v-toolbar>
            <v-form ref="form">
              <Cargos />
            </v-form>
            <v-card-actions class="justify-end">
              <v-btn
                color="primary"
                class="mr-4"
                @click="closeDialog"
              >
                <v-icon
                  left
                  class="mr-3"
                >mdi-close</v-icon>
                Sair
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-container>
    <!-- Dialog cadastro de pessoa -->
      <v-container>
        <v-dialog
          v-model="DialogPessoa"
          transition="dialog-top-transition"
        >
          <v-card tile>
            <v-toolbar
              color="primary"
              dark
              class="mb-2"
            >
              <v-icon large>
                mdi-pencil-box-outline
              </v-icon>
              Adicionar Pessoa
            </v-toolbar>
            <v-form ref="form">
              <Cadastro :btnsair="btnsair" />
            </v-form>
            <v-card-actions class="justify-end">
              <v-btn
                color="primary"
                class="mr-4"
                @click="closeDialogPessoa"
              >
                <v-icon
                  left
                  class="mr-3"
                >mdi-close</v-icon>
                Sair
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-container>
  </v-container>
</template>
<script>
import PageTitle from '@/components/template/PageTitle'
import Cadastro from '@/modules/admin/cadastros/pessoas'
import Cargos from '@/modules/cadastros/components/cargos'
import { mapState } from 'vuex'
import { baseApiUrl, showError } from '@/global'
import moment from 'moment'
import axios from 'axios'
export default {
  name: 'ModuloTercerizados',
  components: { PageTitle, Cadastro, Cargos },
  computed: mapState(['user']),
  data: () => ({
    uuid: '',
    dtp: '##/##/####',
    datp: '##/##/####',
    dtIni: '##/##/####',
    dtFim: '##/##/####',
    tabs: null,
    codigo: '',
    dialog: false,
    DialogAnexo: false,
    DialogPessoa: false,
    dialogCargo: false,
    loading: false,
    uploadReady: true,
    btnsair: true,
    file: '',
    tabela: 'terceiroanexos',
    pasta: 'terceiros',
    search: null,
    select: null,
    listar: '',
    date: new Date().toISOString().substr(0, 10),
    date1: new Date().toISOString().substr(0, 10),
    date2: new Date().toISOString().substr(0, 10),
    date3: new Date().toISOString().substr(0, 10),
    data_pub: '',
    date_pub: '',
    date_ini: '',
    date_fim: '',
    menu: false,
    menu1: false,
    menu2: false,
    menu3: false,
    mode: 'save',
    tercerizado: {},
    pessoa: {},
    anexo: {},
    items: [],
    lotacoes: [],
    pessoas: [],
    orgaos: [],
    cargos: [],
    anexos: [],
    tercerizados: [],
    headers: [
      {
        text: 'Cód',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Nome', value: 'nome_tercerizado' },
      { text: 'Órgão', value: 'orgao' },
      { text: 'Ano', value: 'ano' },
      { text: 'Publicação', value: 'data' },
      { text: 'Situação', value: 'situacao', sortable: false },
      { text: 'Ações', value: 'actions', sortable: false }
    ],
    headersAnexos: [
      {
        text: 'Cód',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Nome', value: 'nome' },
      { text: 'Tabela', value: 'tabela' },
      { text: 'Data', value: 'dtpub' },
      { text: 'Ações', value: 'actions', sortable: false }
    ],
    valid: false
  }),
  methods: {
    dateB () {
      this.data_pub = moment(this.date).format('DD/MM/YYYY')
      this.menu = false
      this.mudaData()
    },
    mudaData () {
      if (!this.data_pub) return
      const dataPub = moment(this.data_pub, 'DD/MM/YYYY', true)
      if (!dataPub.isValid()) return

      this.tercerizado.publicacao = dataPub.format('YYYY-MM-DD')
    },
    dateA () {
      this.date_pub = moment(this.date1).format('DD/MM/YYYY')
      this.menu1 = false
      this.mudaDataA()
    },
    mudaDataA () {
      if (!this.date_pub) return
      const dataAnxo = moment(this.date_pub, 'DD/MM/YYYY', true)
      if (!dataAnxo.isValid()) return

      this.anexo.data_publicacao = dataAnxo.format('YYYY-MM-DD')
    },
    DateC () {
      this.date_ini = moment(this.date2).format('DD/MM/YYYY')
      this.menu2 = false
      this.mudaDataC()
    },
    mudaDataC () {
      if (!this.date_ini) return
      const dataIni = moment(this.date_ini, 'DD/MM/YYYY', true)
      if (!dataIni.isValid()) return

      this.tercerizado.inicio = dataIni.format('YYYY-MM-DD')
    },
    DateB () {
      this.date_fim = moment(this.date3).format('DD/MM/YYYY')
      this.menu3 = false
      this.mudaDataB()
    },
    mudaDataB () {
      if (!this.date_fim) return
      const data = moment(this.date_fim, 'DD/MM/YYYY', true)
      if (!data.isValid()) return

      this.tercerizado.termino = data.format('YYYY-MM-DD')
    },
    validate () {
      this.$refs.form.validate()
    },
    save () {
      const method = this.tercerizado.id ? 'put' : 'post'
      const id = this.tercerizado.id ? `/${this.tercerizado.id}` : ''
      axios[method](`${baseApiUrl}/tercerizados${id}`, this.tercerizado)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.reset()
        })
        .catch(showError)
    },
    selectFile () {
      this.file = this.$refs.file.files[0]
    },
    async fileUpload () {
      const formData = new FormData()
      const method = this.anexo.id ? 'put' : 'post'
      const id = this.anexo.id ? `/${this.anexo.id}` : ''
      const url = `${baseApiUrl}/upload-documentos-em-anexo${id}`
      formData.append('uid_tercerizado', this.tercerizado.id)
      formData.append('data_publicacao', this.anexo.data_publicacao)
      formData.append('nome', this.anexo.nome)
      formData.append('tabela', this.tabela)
      formData.append('pasta', this.pasta)
      formData.append('subpasta', this.tercerizado.id)
      formData.append('usuario', this.anexo.usuario)
      formData.append('file', this.file)
      await axios[method](url, formData)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.resetUpload()
        })
        .catch(showError)
    },
    clearUpload () {
      this.uploadReady = false
      this.$nextTick(() => {
        this.uploadReady = true
      })
    },
    resetUpload () {
      this.file = ''
      this.anexo = {}
      this.uploadReady = false
      this.$nextTick(() => {
        this.uploadReady = true
      })
    },
    saveAnexo () {
      const method = this.anexo.id ? 'put' : 'post'
      const id = this.anexo.id ? `/${this.anexo.id}` : ''
      axios[method](`${baseApiUrl}/anexos${id}`, this.anexo)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.limpar()
          this.loadAnexos()
        })
        .catch(showError)
    },
    remove () {
      alert('Deseja realmente remover?')
    },
    loadAnexos () {
      const id = this.tercerizado.id
      const url = `${baseApiUrl}/anexos-do-tercerizado/${id}`
      axios.get(url).then(res => {
        this.anexos = res.data.map(item => {
          return {
            ...item,
            dtpub: moment(item.data_publicacao).format('DD/MM/YYYY')
          }
        })
      })
    },
    loadUnidades () {
      const id = 32
      const url = `${baseApiUrl}/unidades-por-categoria/${id}`
      axios.get(url).then(res => {
        this.orgaos = res.data.map(item => {
          return {
            value: item.id,
            text: item.unidade
          }
        })
      })
    },
    loadLotacao () {
      const url = `${baseApiUrl}/lista-unidade-for-select`
      axios.get(url).then(res => {
        this.lotacoes = res.data.map(item => {
          return {
            value: item.id,
            text: item.unidade
          }
        })
      })
    },
    loadCargos () {
      const url = `${baseApiUrl}/cargos-e-funcoes`
      axios.get(url).then(res => {
        this.cargos = res.data.map(item => {
          return {
            value: item.id,
            text: item.cargo
          }
        })
      })
    },
    loadOrgaos () {
      const url = `${baseApiUrl}/gestoes`
      axios.get(url).then(res => {
        this.orgaos = res.data.map(item => {
          return {
            value: item.id,
            text: item.gestao
          }
        })
      })
    },
    loadTercerizados () {
      const url = `${baseApiUrl}/tercerizados-filtro`
      axios.get(url).then(res => {
        this.tercerizados = res.data.map(item => {
          return {
            ...item,
            data: moment(item.publicacao).format('DD/MM/YYYY'),
            situacao: item.inativar === 0 ? 'Ativo' : 'Inativo'
          }
        })
      })
    },
    loadTercerizado (item, mode = 'save') {
      this.mode = mode
      const url = `${baseApiUrl}/tercerizados/${item.id}`
      axios.get(url).then(res => {
        this.tercerizado = res.data
        this.data_pub = moment(this.tercerizado.publicacao).format('DD/MM/YYYY')
        if (this.tercerizado.inicio) {
          this.date_ini = moment(this.tercerizado.inicio).format('DD/MM/YYYY')
          this.tercerizado.inicio = moment(this.tercerizado.inicio).format('YYYY-MM-DD')
        }
        if (this.tercerizado.termino) {
          this.date_fim = moment(this.tercerizado.termino).format('DD/MM/YYYY')
          this.tercerizado.termino = moment(this.tercerizado.termino).format('YYYY-MM-DD')
        }
        this.codigo = this.tercerizado.id
        const un = this.tercerizado.uid_orgao
        this.loadLotacao(un)
        this.loadDatas()
      })
      this.dialog = false
      this.valid = true
    },
    loadPedidoPessoaId (item) {
      const id = this.tercerizado.uid_pessoa ? `/${this.tercerizado.uid_pessoa}` : `/${item.uid_pessoa}`
      const url = `${baseApiUrl}/servidores-por-id${id}`
      axios.get(url).then(res => {
        this.pessoa = res.data
        this.tercerizado.uid_pessoa = this.pessoa.uid_pessoa
        this.tercerizado.nome_tercerizado = this.pessoa.agente
        this.tercerizado.cpf = this.pessoa.cpf_txt ? String(this.pessoa.cpf_txt).substr(0, 3) + '.***.***-' + String(this.pessoa.cpf_txt).substr(12, 2) : '***.***.***-**'
      })
      this.clPessoa()
    },
    loadSeach (listar = 'sim') {
      const search = this.tercerizado.nome_tercerizado || 0
      const url = `${baseApiUrl}/servidores-search/${search}`
      axios.get(url).then(res => {
        this.items = res.data
      })
      this.listar = listar
    },
    loadFtPessoa () {

    },
    loadAddPessoa () {
      this.assunto = {}
      this.DialogPessoa = true
    },
    loadFtCargo () {

    },
    loadAddCargo () {
      this.dialogCargo = true
    },
    closeDialog () {
      this.dialogCargo = false
      this.loadCargos()
    },
    clPessoa () {
      this.tercerizado.uid_pessoa = ''
      this.tercerizado.nome_tercerizado = ''
      this.tercerizado.cpf = ''
      this.items = []
      this.listar = ''
    },
    loadAnexo (anexo, mode = 'save') {
      this.mode = mode
      this.anexo = { ...anexo }
      this.anexo.usuario = this.user.id
      this.DialogAnexo = true
    },
    AddAnexo () {
      this.anexo.usuario = this.user.id
      this.anexo.uid_tercerizado = this.tercerizado.id
      this.DialogAnexo = true
    },
    reset () {
      this.$refs.form.reset()
      this.valid = true
      this.mode = 'save'
      this.tercerizado = {}
      this.anexos = []
      this.tercerizado.usuario = this.user.id
    },
    limpar () {
      this.mode = 'save'
      this.anexo = {}
      this.anexo.usuario = this.user.id
      this.anexo.uid_tercerizado = this.tercerizado.id
    },
    FecharDialog () {
      this.DialogAnexo = false
      this.limpar()
    },
    closeDialogPessoa () {
      this.DialogPessoa = false
    },
    adicionarAnexo () {
      this.saveAnexo()
    },
    adicionarAnexoSair () {
      this.saveAnexo()
      this.DialogAnexo = false
    },
    loadDialog () {
      this.dialog = true
      this.loadTercerizados()
    },
    loadDatas () {
      this.mudaData()
      this.mudaDataA()
      this.mudaDataC()
      this.mudaDataB()
    },
    loadUser () {
      this.tercerizado.usuario = this.user.id
    }
  },
  mounted () {
    this.loadUser()
    this.loadUnidades()
    this.loadCargos()
  }
}
</script>

<style scoped>
.altura {
  min-height: 380px !important;
}
.text-v-card {
  font-size: 1rem !important;
}
.codigo {
  max-width: 100% !important;
}
.v-busca-nome {
  max-width: 100% !important;
  height: 45px !important;
}
.v-input__prepend-outer {
  padding: 0px !important;
  width: 36px !important;
  height: 36px !important;
}
.btn-outer {
  margin-top: -7px !important;
  margin-left: -9px !important;
}
.btn-outer-left {
  margin-top: -7px !important;
  margin-right: -11px !important;
}
.btn-outer-right {
  margin-top: -7px !important;
  margin-right: -11px !important;
}
.btn-outer-right-1 {
  margin-top: -8px !important;
  margin-left: -12px !important;
  border-top: solid 1px #878f97 !important;
  border-right: solid 1px #878f97 !important;
  border-bottom: solid 1px #878f97 !important;
}
.v-icon-btn {
  margin-top: -7px !important;
  margin-right: -8px !important;
  padding: auto !important;
  background-color: rgb(12, 94, 46);
}
ul.filtro {
  position: absolute;
  min-width: 350px;
  top: 0px;
  left: 40px;
  padding: 2px 6px !important;
  background-color: #feffff;
  border: solid 1px #000;
  list-style: none;
  z-index: 1000;
}
ul.filtro li a {
  text-decoration: none;
  color: #333 !important;
}
ul.filtro li:hover {
  background-color: teal;
  color: #ffffff !important;
}
ul.filtro li a:hover {
  color: #ffffff !important;
}
.container {
  width: 98% !important;
}
.logo-foto {
  max-width: 750px;
}
</style>
